<template>
  <div class="operation-report-show-body-header-action-buttons flex">
    <download-button
      class="action-download-button"
      v-if="canDownload"
      @click="onClickDownload"
    ></download-button>
    <edit-button v-if="canEdit" @click="onClickEdit"></edit-button>
    <delete-button v-if="canDelete" @click="onClickDelete"></delete-button>
  </div>
</template>

<script>
import EditButton from "./EditButton";
import DeleteButton from "./DeleteButton";
import DownloadButton from "../../../../../components/buttons/DownloadButton.vue";
import isObject from "lodash/isObject";

const EVENTS = {
  DOWNLOAD: "download",
  EDIT: "edit",
  DELETE: "delete",
};

export default {
  name: "OperationReportShowBodyHeaderActionButtons",

  components: {
    DownloadButton,
    EditButton,
    DeleteButton,
  },

  props: {
    privilege: {
      type: Object, // { canDownload: Boolean, canEdit: Boolean, canDelete: Boolean }
      default: () => ({
        canDownload: false,
        canEdit: false,
        canDelete: false,
      }),
    },
  },

  computed: {
    canDownload() {
      if (!isObject(this.privilege)) return false;
      return this.privilege.canDownload === true;
    },
    canEdit() {
      if (!isObject(this.privilege)) return false;
      return this.privilege.canEdit === true;
    },
    canDelete() {
      if (!isObject(this.privilege)) return false;
      return this.privilege.canDelete === true;
    },
  },

  methods: {
    onClickDownload() {
      this.$emit(EVENTS.DOWNLOAD);
    },
    onClickEdit() {
      this.$emit(EVENTS.EDIT);
    },
    onClickDelete() {
      this.$emit(EVENTS.DELETE);
    },
  },
};
</script>
<style lang="scss" scoped>
.operation-report-show-body-header-action-buttons {
  height: 50px;
  column-gap: 20px;

  // このActionButtons内で使用するDownloadButtonの高さを50pxに調整
  ::v-deep .action-download-button {
    .download-button {
      height: 50px !important;
    }
  }
}
</style>
